module.exports = __webpack_public_path__ + "img/gift.d474d774.svg";